import { render, staticRenderFns } from "./OwnerDepartures.vue?vue&type=template&id=a1174cac&"
import script from "./OwnerDepartures.vue?vue&type=script&lang=js&"
export * from "./OwnerDepartures.vue?vue&type=script&lang=js&"
import style0 from "./OwnerDepartures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports